module.exports = __webpack_public_path__ + "img/afrique.6c2f28b8.png";